'use strict';

module.exports = function(context, from, to) {
  var templates = {};
  context.keys().forEach(function(key) {
    templates[from && to ? key.replace(from, to) : key] = context(key);
  });

  return templates;
};



//////////////////
// WEBPACK FOOTER
// (webpack)-require_context/index.js
// module id = 1045
// module chunks = 0